"use strict";module.exports=function(r,i){for(var t=r.split("."),s=i.split("."),e=0;e<3;e++){var u=+t[e],N=+s[e];if(u>N)return 1;if(N>u)return-1;if(!isNaN(u)&&isNaN(N))return 1;if(isNaN(u)&&!isNaN(N))return-1}return 0};
//# sourceMappingURL=index.cjs.js.map
